import React from 'react';
import {appConstants} from "../../../_constants";
import IconCheck from 'react-icons/lib/md/check-box';
import IconError from 'react-icons/lib/md/error-outline';
import IconCheckIndeterminate from 'react-icons/lib/md/indeterminate-check-box';
import IconCancel from 'react-icons/lib/md/cancel';
import IconPending from 'react-icons/lib/md/warning';
import IconProcess from 'react-icons/lib/md/send';
import IconPartial from 'react-icons/lib/md/pause';
import {DropdownItem} from "reactstrap";

// const iconType = (notificationType) => {
//     switch (notificationType) {
//         case appConstants.NOTIFICATION_TYPES.PULL_MODE:
//             return <IconCheckIndeterminate size="28" className="text-success"/>;
//         case appConstants.NOTIFICATION_TYPES.MANIFEST_SUCCESS:
//            return <IconCheck size="28" className="text-success"/>;
//         case appConstants.NOTIFICATION_TYPES.MANIFEST_FAILED:
//            return <IconCancel size="28" className="text-success"/>;
//         case appConstants.NOTIFICATION_TYPES.PULL_FAILED:
//             return <IconCancel size="28" className="text-warning"/>;
//         case appConstants.NOTIFICATION_TYPES.AIRLINE_ERROR:
//            return <IconError size="28" className="text-warning"/>;
//         default:
//             return <IconCheck size="28" className="text-success"/>;
//
//     }
// };
// const notification = (props) => {
//     const { pullModeValue, notificationType, pullModeName } = props;
//     return (
//         <DropdownItem className="d-flex align-items-center">
//                 {iconType(notificationType)}
//                 <div className={"ml-3"}>
//                 <div>
//                     {
//                         (pullModeValue > 1) ? `${pullModeValue} files were pulled from ${pullModeName}` : `${pullModeValue} file was pulled from ${pullModeName}`
//                     }
//                 </div>
//                 </div>
//         </DropdownItem>
//     )
//     };

const iconType = (props) => {
    const { pullModeValue, notificationType, pullModeName, manifestStatusValue } = props;
    switch (notificationType) {
        case appConstants.NOTIFICATION_TYPES.PULL_MODE:
            return (
                <DropdownItem className="d-flex align-items-center">
                    <IconCheckIndeterminate size="28" className="text-success"/>
                    <div className={"ml-3"}>
                        <div>
                            {
                                (pullModeValue > 1) ?  ` ${pullModeValue} files were pulled from ${pullModeName}` : `${pullModeValue} file was pulled from ${pullModeName}`

                            }
                        </div>
                    </div>
                </DropdownItem>
            );
        case appConstants.NOTIFICATION_TYPES.MANIFEST_SUCCESS:
            return (
                    <DropdownItem className="d-flex align-items-center">
                        <IconCheck size="28" className="text-success"/>
                        <div className={"ml-3"}>
                            <div>
                                {
                                    (manifestStatusValue > 1 ) ? `${manifestStatusValue} files were processed successfully` : `${manifestStatusValue} file was processed successfully`
                                }
                            </div>
                        </div>
                    </DropdownItem>
                );
        case appConstants.NOTIFICATION_TYPES.MANIFEST_FAILED:
            return (
                <DropdownItem className="d-flex align-items-center">
                    <IconCancel size="28" className="text-danger"/>
                    <div className={"ml-3"}>
                        <div>
                            {
                                (manifestStatusValue > 1 ) ? `${manifestStatusValue} files failed to be processed` : `${manifestStatusValue} file failed to be processed`
                            }
                        </div>
                    </div>
                </DropdownItem>
            );
        case appConstants.NOTIFICATION_TYPES.MANIFEST_PENDING:
            return (
                <DropdownItem className="d-flex align-items-center">
                    <IconPending size="28" className="text-warning"/>
                    <div className={"ml-3"}>
                        <div>
                            {
                                (manifestStatusValue > 1 ) ? `${manifestStatusValue} files is pending to processed` : `${manifestStatusValue} file is pending to be processed`
                            }
                        </div>
                    </div>
                </DropdownItem>
            );
        case appConstants.NOTIFICATION_TYPES.MANIFEST_PROCESSING:
            return (
                <DropdownItem className="d-flex align-items-center">
                    <IconProcess size="28" className="text-info"/>
                    <div className={"ml-3"}>
                        <div>
                            {
                                (manifestStatusValue > 1 ) ? `${manifestStatusValue} files is processing` : `${manifestStatusValue} file is processing`
                            }
                        </div>
                    </div>
                </DropdownItem>
            );
        case appConstants.NOTIFICATION_TYPES.MANIFEST_PARTIAL:
            return (
                <DropdownItem className="d-flex align-items-center">
                    <IconPartial size="28" className="text-warning"/>
                    <div className={"ml-3"}>
                        <div>
                            {
                                (manifestStatusValue > 1 ) ? `${manifestStatusValue} files is partially processed` : `${manifestStatusValue} file is partially processed`
                            }
                        </div>
                    </div>
                </DropdownItem>
            );
        case appConstants.NOTIFICATION_TYPES.PULL_FAILED:
            return <IconCancel size="28" className="text-warning"/>;
        case appConstants.NOTIFICATION_TYPES.AIRLINE_ERROR:
            return <IconError size="28" className="text-warning"/>;
        default:
            return null;

    }
};

export default iconType;


// WEBPACK FOOTER //
// ./src/shared/components/notification/index.js